import { render } from "./Step5KeepItUp.vue?vue&type=template&id=b87909ce"
import script from "./Step5KeepItUp.vue?vue&type=script&lang=js"
export * from "./Step5KeepItUp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__